import React, { useEffect, useContext } from "react";
import "./Subscriptions.css";
import { TableContext } from '../context';
import NotificationCenter from "./NotificationCenter";

const Subscriptions = () => {
  const { getNotifications, tokenFetched } = useContext(TableContext);

  useEffect(() => {
    if (tokenFetched){
      getNotifications();
    }
  }, [tokenFetched]);

  return (
    <div className="subscription-container">
      <NotificationCenter />
    </div>
  );
};

export default Subscriptions;